import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UnderstandingSMPSHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-12.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .usm { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .usm-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .usm-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .usm-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .usm-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .usm-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 520px;
  }
  .usm-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .usm-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .usm-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .usm-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .usm-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .usm-bc-item:hover { color: #EB2019; }
  .usm-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .usm-bc-sep img { width: 24px; height: 24px; display: block; }
  .usm-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .usm-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .usm-main-section { padding: 80px 0 120px 0; }
  .usm-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .usm-article { flex: 1; min-width: 0; }

  .usm-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .usm-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .usm-meta-item:last-child { border-right: none; padding-right: 0; }
  .usm-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .usm-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .usm-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .usm-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .usm-article-body p { margin-bottom: 20px; }
  .usm-article-body p:last-child { margin-bottom: 0; }

  .usm-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 5px 0 15px 0; line-height: 160%; display: block;
  }

  /* Bullet list */
  .usm-article-body ul {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 15px;
  }
  .usm-article-body ul li {
    display: flex; align-items: flex-start; gap: 10px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .usm-article-body ul li::before {
    content: '•'; color: #202020;
    font-size: 16px; line-height: 160%; flex-shrink: 0;
  }
  .usm-article-body ul li > span { flex: 1; }

  .usm-article-body strong { font-weight: 600; color: #202020; }

  .usm-red-link { color: #EB2019; text-decoration: underline;  font-weight:600;}
  .usm-red-link:hover { opacity: 0.8; }

  /* Hashtags */
  .usm-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .usm-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .usm-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .usm-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .usm-nav-btn:hover { color: #EB2019; }
  .usm-nav-btn img { width: 40px; height: 40px; display: block; }

  .usm-share-icons { display: flex; align-items: center; gap: 20px; }
  .usm-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .usm-share-icon:hover { opacity: 0.85; }
  .usm-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .usm-sidebar { flex: 0 0 475px; }
  .usm-sidebar-block { margin-bottom: 60px; }
  .usm-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .usm-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .usm-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .usm-recent-item:hover .usm-recent-title { color: #EB2019; }
  .usm-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .usm-recent-body { flex: 1; min-width: 0; }
  .usm-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .usm-social-icons { display: flex; align-items: center; gap: 30px; }
  .usm-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .usm-social-icon:hover { opacity: 0.8; }
  .usm-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .usm-hero             { height: 350px; }
    .usm-hero-content     { padding: 0 32px; }
    .usm-hero-title       { font-size: 30px; }
    .usm-hero-divider     { width: 100%; max-width: 479px; }
    .usm-breadcrumb       { padding: 24px 0 0 0; }
    .usm-breadcrumb-inner { padding: 0 32px; }
    .usm-inner            { padding: 0 32px; }
    .usm-main-section     { padding: 48px 0 60px 0; }
    .usm-main-row         { flex-direction: column; gap: 48px; }
    .usm-sidebar          { flex: none; width: 100%; }
    .usm-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .usm-hero             { height: 360px; }
    .usm-hero-content     { padding: 0 16px; }
    .usm-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .usm-hero-divider     { width: 100%; }
    .usm-hero-subtitle    { font-size: 14px; }
    .usm-breadcrumb       { padding: 30px 0 0 0; }
    .usm-breadcrumb-inner { padding: 0 16px; }
    .usm-bc-item          { font-size: 14px; gap: 14px; }
    .usm-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .usm-bc-sep img       { width: 22px; height: 22px; }
    .usm-inner            { padding: 0 16px; }
    .usm-main-section     { padding: 30px 0 60px 0; }
    .usm-main-row         { flex-direction: column; gap: 60px; }
    .usm-sidebar          { flex: none; width: 100%; }
    .usm-article-title    { font-size: 20px; margin-bottom: 15px; }
    .usm-article-body     { font-size: 14px; }
    .usm-meta-item        { font-size: 14px; }
    .usm-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .usm-h2               { font-size: 16px; margin: 30px 0 15px 0; }
    .usm-nav-btn img      { width: 24px; height: 24px; }
    .usm-nav-btn          { font-size: 14px; }
    .usm-share-icon img   { width: 34px; height: 34px; }
    .usm-hashtags         { margin-top: 30px; }
    .usm-article-body p { margin-bottom: 15px;}
    .usm-article-body ul li { font-size: 14px; }


  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
      title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },


];

export default function UnderstandingSwitchModePowerSupplies() {
  return (
    <div className="usm">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="usm-hero">
        <img className="usm-hero-bg" src={HeroBgImg} alt="Understanding SMPS Hero" />
        <div className="usm-hero-overlay" />
        <div className="usm-hero-content">
          <h1 className="usm-hero-title">
            Understanding Switch Mode Power Supplies: How They Work and Why They Matter
          </h1>
          <hr className="usm-hero-divider" />
          <p className="usm-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="usm-breadcrumb" aria-label="Breadcrumb">
        <div className="usm-breadcrumb-inner">
          <a href="/" className="usm-bc-item">Home</a>
          <span className="usm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="usm-bc-item">News &amp; Updates</a>
          <span className="usm-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="usm-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="usm-main-section">
        <div className="usm-inner">
          <div className="usm-main-row">

            {/* ── ARTICLE ── */}
            <article className="usm-article">

              {/* Meta bar */}
              <div className="usm-meta-bar">
                <span className="usm-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="usm-meta-item"><img src={CalendarIcon} alt="date" /> May 16, 2025</span>
                <span className="usm-meta-item"><img src={ClockIconImg} alt="time" /> 11:56 am</span>
                <span className="usm-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="usm-article-title">
                Understanding Switch Mode Power Supplies: How They Work and Why They Matter
              </h1>

              {/* Body */}
              <div className="usm-article-body">

                <p>Today's electronic world is tech-driven, and electronic devices like TVs, mobiles, and laptops are becoming essential parts of our lives. These devices need efficient power sources, which is where Switch Mode Power Supplies come in.</p>

                <p><strong>SMPS</strong>  has involved the way electronic devices are powered, offering greater safety and efficiency. Whether you are powering an industrial control system or just your gadget, it's essential to understand the functions and workings of <strong>SMPS.</strong></p>

                {/* Article image */}
                <img className="usm-article-img" src={ArticleImg} alt="SMPS Power Supply" />

                <p>This blog explains what SMPS are, how they work, their types and applications, and why they are important in today's tech-driven industries.<br />
                Let's dive in!</p>

                <span className="usm-h2">How do Switch Mode Power Supplies work?</span>

                <p>Here is the step-by-step explanation:</p>

                <ul>
                  <li><span><strong>AC input:</strong> Alternating Current is taken in from the wall outlet.</span></li>
                  <li><span><strong>Rectification:</strong> The Alternating Current is first converted into Direct Current using a rectifier.</span></li>
                  <li><span><strong>Switching:</strong> DC is chopped into high-frequency pulses by high-speed transistors.</span></li>
                  <li><span><strong>Transformer:</strong> Changing the voltage level by feeding the pulses into a transformer.</span></li>
                  <li><span><strong>Output Rectification and Filtration:</strong> The output voltage is converted back to a smooth DC.</span></li>
                  <li><span><strong>Control Feedback:</strong> Constantly adjusts switching to maintain a stable output.</span></li>
                </ul>

                <span className="usm-h2">Types of Switch-Mode Power Supplies</span>

                <p>SMPS are classified based on their topology and applications:</p>

                <ul>
                  <li><span>Buck Converter</span></li>
                  <li><span>Boost Converter</span></li>
                  <li><span>Buck-Boost Converter</span></li>
                  <li><span>Forward Converter</span></li>
                  <li><span>Flyback Converter</span></li>
                </ul>

                <span className="usm-h2">Applications of Switch-Mode Power Supplies</span>

                <p>Some key applications include:</p>

                <ul>
                  <li><span><strong>Electronic gadgets:</strong> Laptops, TVs, Mobiles, Refrigerators</span></li>
                  <li><span><strong>Industries:</strong> Automation and Control units</span></li>
                  <li><span><strong>Telecom:</strong> Network routers and Data centers</span></li>
                  <li><span><strong>Automotives:</strong> EVs, LED lights, Battery management, charging ports</span></li>
                  <li><span><strong>Healthcare:</strong> ECG, MRI, CT scanners, X-ray machines, Ultrasound</span></li>
                </ul>

                <span className="usm-h2">Let's understand why SMPS matters.</span>

                <p><strong>SMPS</strong> offers several advantages that make it essential across industries. Let's explore how <strong>SMPS</strong> makes devices smarter and more sustainable.</p>

                <p><strong>Efficiency:</strong> Traditional linear power supplies use excess voltage, leading to energy loss in high-power applications. Where <a href="/smps" className="usm-red-link">SMPS</a> reaches over 90% efficiency and reduces power loss.</p>

                <p><strong>Thermal Management: SMPS</strong> produces less heat, reducing the necessity of heat sinks and fans. This improves the system's overall efficiency and extends longevity and reliability.</p>

                <p><strong>Lightweight Design: SMPS</strong> uses much smaller transformers and other components, making it lighter without compromising power delivery.</p>

                <p><strong>Compliance with Regulatory Standards:</strong> With increased safety, efficiency, and reliability,</p>

                <p><strong>Switch Mode Power Supplies</strong> are helping the products meet global environmental standards.</p>

                <span className="usm-h2">In Essence</span>

                <p><strong>Switch-mode power supplies (SMPS)</strong> have evolved the power delivery system in electronics. From mobile chargers to high-power equipment, they play an essential role in safety, efficiency, and performance. With technological advancements, it is important to understand the usefulness of <strong>SMPS power.</strong></p>

                <p>At <strong>Ador Powertron,</strong> we master designing compact, innovative, and reliable SMPS technologies that deliver performance.</p>

                <p><a href="/contact" className="usm-red-link">Contact us today</a>, to discover the right <strong>SMPS</strong> solutions that match your business goals.</p>

                <p className="usm-hashtags">#switchmodepowersupply #smps #smpspower #SMPS #Ador #Adorpowertron #SMPStechnologies</p>

              </div>

              {/* ── Bottom row ── */}
              <div className="usm-bottom-row">
                <div className="usm-bottom-nav">
                  <a href="/news/complete-guide-emission-control-systems" className="usm-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/upgrading-transformer-rectifier-system" className="usm-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="usm-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/understanding-switch-mode-power-supplies-how-they-work-and-why-they-matter/" className="usm-share-icon" aria-label="Facebook"  target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Funderstanding-switch-mode-power-supplies-how-they-work-and-why-they-matter%2F&mode=login" className="usm-share-icon" aria-label="Twitter"  target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-switch-mode-power-supplies-how-they-work-and-why-they-matter%2F%26title%3DUnderstanding%2520Switch%2520Mode%2520Power%2520Supply%2520%257C%2520Adorpower%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Funderstanding-switch-mode-power-supplies-how-they-work-and-why-they-matter%2F" className="usm-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="usm-sidebar">

              {/* Recent Posts */}
              <div className="usm-sidebar-block">
                <p className="usm-sidebar-title">Recent Posts</p>
                <div className="usm-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="usm-recent-item">
                      <img src={post.img} alt={post.title} className="usm-recent-img" />
                      <div className="usm-recent-body">
                        <span className="usm-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="usm-sidebar-block">
                <p className="usm-sidebar-title">Social Media</p>
                <div className="usm-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="usm-social-icon" aria-label="YouTube"  target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="usm-social-icon" aria-label="LinkedIn"  target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}